<template>
  <v-col class="pa-0">
    <div class="font-weight-bold">
      {{ this.label }}
    </div>

    <div
      class="elevation-4 mt-2 pa-2 d-flex flex-wrap"
      v-for="block in blocks"
      :key="`block-${block}`"
    >
      <template v-for="field in params.fields">
        <div
          :key="`linebreak-${field.sequence}`"
          v-if="(field.config || {}).inline !== 'true'"
          class="linebreak"
        ></div>

        <Field
          :ref="`field-${field.alias}-${block}`"
          :key="field.sequence"
          :expressionInterpreter="interpreters[block][field.alias]"
          :label="field.name"
          :required="field.required"
          :alias="field.alias"
          :type="field.type.name"
          :config="field.config"
          :params="field.params"
          :dependency="field.dependency"
          :disabled="disabled"
          @hook:mounted="linkFieldValue(block, field.alias)"
        ></Field>
      </template>

      <!-- linebreak for add/remove buttons -->
      <div class="linebreak"></div>
      <div class="col-12 pa-0">
        <v-btn
          v-if="!isMaxGroup"
          icon
          @click="insertBlock(block)"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-btn
          v-if="blocks.length > 1"
          icon
          @click="clearBlock(block)"
        >
          <v-icon>mdi-minus</v-icon>
        </v-btn>
      </div>
    </div>

    <p
      v-if="this.isMaxGroup"
      class="mt-4 msg-error"
    >
      {{ this.params.msg }}
    </p>

  </v-col>
</template>

<script>
import Field from '../Field.vue';
import FormExpressionInterpreter from '../form-expression-interpreter';

export default {
  props: {
    label: String,
    hint: String,
    placeholder: String,
    messageEmpty: String,
    disabled: Boolean,
    parentInterpreter: Object,
    initialValue: {
      required: false,
    },
    inputData: Object,
    params: {
      type: Object,
      default: () => ({}),
    },
    required: {
      type: Boolean,
      default: () => false,
    },
  },
  components: { Field },
  data: () => ({
    blocks: [],
    interpreters: {},
    fieldValue: {},
    watchers: {},
    isMaxGroup: false,
  }),
  created() {
    // create default block context
    this.insertBlock(0);
  },
  destroy() {
    Object.keys(this.watchers)
      .forEach((block) => this.watchers[block].forEach((w) => w()));
  },
  computed: {
    /* fieldValue() {
      // each block will be mapped to an object
      const { fields } = this.params;
      return this.blocks.map((block) => fields
        .map((f) => f.alias)
        .reduce((root, alias) => {
          const { fieldValue } = (this.$refs[`field-${alias}-${block}`] || [])[0] || {};
          // eslint-disable-next-line no-param-reassign
          root[alias] = fieldValue;
          return root;
        }, {}));
      return {};
    }, */
  },
  methods: {
    notifyChange() {
      const parsedFieldValue = Object.keys(this.fieldValue)
        .map((block) => Object.keys(this.fieldValue[block])
          .reduce((tot, alias) => {
            // eslint-disable-next-line no-param-reassign
            tot[alias] = this.fieldValue[block][alias].value;
            return tot;
          }, {}));
      this.$emit('update:inputData', { value: parsedFieldValue });
    },
    linkFieldValue(block, alias) {
      if (!this.fieldValue[block]) {
        this.fieldValue[block] = {};
        this.watchers[block] = [];
      }

      this.watchers[block].push(this.$watch(() => this.$refs[`field-${alias}-${block}`][0].fieldValue, (value) => {
        this.fieldValue[block][alias] = value;
        this.notifyChange();
      }));
    },
    createContext(block) {
      const expressionInterpreter = new FormExpressionInterpreter({
        staticContextFields: {
          user: this.$store.getters['session/user'],
        },
        getFieldsCtx: this.getFieldsCtx(block),
      });

      if (this.params.fields != null && this.params.fields.length) {
        // we will instance the interpreter one time
        // if we define the interpreter in the template we will create
        // an interpreter instance per render and the component will be rendered one time
        // per parent context change.
        this.params.fields.reduce((tot, field) => {
          if (!this.interpreters[block]) {
            this.interpreters[block] = {};
          }
          // insert interpreter at block position
          this.interpreters[block][field.alias] = expressionInterpreter.interpreter(field.alias);
          return tot;
        }, {});
      }
    },
    getFieldsCtx(block) {
      return () => {
        const parentContext = this.parentInterpreter.ctx;
        const groupContext = this.params.fields.reduce((tot, field) => {
          const component = (this.$refs[`field-${field.alias}-${block}`] || [])[0];
          // eslint-disable-next-line no-param-reassign
          tot[field.alias] = (component || {}).fieldValue;
          return tot;
        }, {});

        const ctx = {
          ...parentContext,
          ...groupContext,
        };

        return ctx;
      };
    },
    insertBlock(pBlock) {
      let block = this.blocks.length;
      if (block >= this.params.numMaxGroup - 1) {
        this.isMaxGroup = true;
      }

      while (this.blocks.includes(block)) {
        block += 1;
      }

      this.createContext(block);
      const blockIndex = this.blocks.indexOf(pBlock);
      if (blockIndex >= 0) {
        this.blocks.splice(blockIndex + 1, 0, block);
      } else {
        this.blocks.push(block);
      }
    },
    clearBlock(block) {
      this.isMaxGroup = false;
      this.watchers[block].forEach((w) => w());
      this.blocks.splice(this.blocks.indexOf(block), 1);
      delete this.watchers[block];
      delete this.fieldValue[block];
      delete this.interpreters[block];
      this.notifyChange();
    },
  },
};
</script>
<style>
  .msg-error {
    color: #b64351;
    line-height: 12px;
    font-size: 12px;
    padding: 0 12px;
    margin-bottom: 8px;
  }
</style>
